import moment from "moment";
import { capitalizeFirstLetter } from "../";

export const formatDateDayMonthYearTime = (date: Date) => {
  const formattedDate = moment(date).format("DD MMM YYYY HH:mm");
  const [day, month, year, time] = formattedDate.split(" ");
  const capitalizedMonth = capitalizeFirstLetter(month);
  return `${day} ${capitalizedMonth} ${year} ${time}`;
};
